"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessUnit = exports.businessUnits = exports.Quench = exports.France = exports.Ireland = exports.CzechRepublic = exports.Bulgaria = exports.Finland = exports.Norway = exports.Sweden = exports.Denmark = exports.Netherlands = exports.Lithuania = exports.Estonia = exports.Latvia = exports.Poland = exports.UnitedKingdom = exports.Belgium = exports.Hungary = exports.Switzerland = exports.Italy = exports.Austria = exports.Germany = exports.Portugal = exports.Spain = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.BusinessUnit.Base';
class Spain extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Spain`)('ESP', {}) {
    static label = 'Spain';
}
exports.Spain = Spain;
class Portugal extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Portugal`)('PRT', {}) {
    static label = 'Portugal';
}
exports.Portugal = Portugal;
class Germany extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Germany`)('DEU', {}) {
    static label = 'Germany';
}
exports.Germany = Germany;
class Austria extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Austria`)('AUT', {}) {
    static label = 'Austria';
}
exports.Austria = Austria;
class Italy extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Italy`)('ITA', {}) {
    static label = 'Italy';
}
exports.Italy = Italy;
class Switzerland extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Switzerland`)('CHE', {}) {
    static label = 'Switzerland';
}
exports.Switzerland = Switzerland;
class Hungary extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Hungary`)('HUN', {}) {
    static label = 'Hungary';
}
exports.Hungary = Hungary;
class Belgium extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Belgium`)('BEL', {}) {
    static label = 'Belgium';
}
exports.Belgium = Belgium;
class UnitedKingdom extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.UnitedKingdom`)('GBR', {}) {
    static label = 'UK';
}
exports.UnitedKingdom = UnitedKingdom;
class Poland extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Poland`)('POL', {}) {
    static label = 'Poland';
}
exports.Poland = Poland;
class Latvia extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Latvia`)('LVA', {}) {
    static label = 'Latvia';
}
exports.Latvia = Latvia;
class Estonia extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Estonia`)('EST', {}) {
    static label = 'Estonia';
}
exports.Estonia = Estonia;
class Lithuania extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Lithuania`)('LTU', {}) {
    static label = 'Lithuania';
}
exports.Lithuania = Lithuania;
class Netherlands extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Netherlands`)('NLD', {}) {
    static label = 'Netherlands';
}
exports.Netherlands = Netherlands;
class Denmark extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Denmark`)('DNK', {}) {
    static label = 'Denmark';
}
exports.Denmark = Denmark;
class Sweden extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Sweden`)('SWE', {}) {
    static label = 'Sweden';
}
exports.Sweden = Sweden;
class Norway extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Norway`)('NOR', {}) {
    static label = 'Norway';
}
exports.Norway = Norway;
class Finland extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Finland`)('FIN', {}) {
    static label = 'Finland';
}
exports.Finland = Finland;
class Bulgaria extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Bulgaria`)('BGR', {}) {
    static label = 'Bulgaria';
}
exports.Bulgaria = Bulgaria;
class CzechRepublic extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.CzechRepublic`)('CZE', {}) {
    static label = 'Czech Rep.';
}
exports.CzechRepublic = CzechRepublic;
class Ireland extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Ireland`)('IRL', {}) {
    static label = 'Ireland';
}
exports.Ireland = Ireland;
class France extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.France`)('FRA', {}) {
    static label = 'France';
}
exports.France = France;
class Quench extends effect_1.Schema.TaggedClass(`${exports.NAMESPACE}.Quench`)('QNC', {}) {
    static label = 'Quench';
}
exports.Quench = Quench;
exports.businessUnits = {
    Spain,
    Portugal,
    Germany,
    Austria,
    Italy,
    Switzerland,
    Hungary,
    Belgium,
    UnitedKingdom,
    Poland,
    Latvia,
    Estonia,
    Lithuania,
    Netherlands,
    Denmark,
    Sweden,
    Norway,
    Finland,
    Bulgaria,
    CzechRepublic,
    Ireland,
    France,
    Quench,
};
exports.BusinessUnit = effect_1.Schema.Union(...effect_1.Record.values(exports.businessUnits)).annotations({
    identifier: `${exports.NAMESPACE}.BusinessUnit`,
});
//# sourceMappingURL=base.js.map